<template>
  <div id="loader">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.querySelector("footer").style.display = "none";
  },
  unmounted() {
    document.querySelector("footer").style.display = "";
  },
};
</script>

<style>
#loader {
  background-color: transparent;
  height: 100vh;
  width: 100vw;
  z-index: 9999;
  display: grid;
  place-items: center;
  position: fixed;
  top: 0;
  left: 0;
}

/* Pure CSS spinner */
.spinner {
  width: 48px;
  height: 48px;
  border: 5px solid #ffffff;
  border-top: 5px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Spin animation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
